export class AuditMetadata {
    createdDateTime: string;
    modifiedDateTime: string;
    createdBy?: string;
    modifiedBy?: string;
}
